import { BonusAnalysisResult } from "@bonusmap/api-types";
import { BaseWebComponent } from "../base-components/base-web-component";
import { BaFile } from "./ba-file";
import { BaPanel } from "./ba-panel";
import { BaProcessing } from "./ba-processing";
import { BaViewerControl } from "./ba-viewer-control";
import { bonusAiStorage } from "./bonus-ai-storage";
export interface BonusAddFile extends File {
    base64?: string;
}
export class BonusAddAi extends BaseWebComponent {
    static override webComponentName: string = "bonus-add-ai";
    protected override _templateId: string = "bonus-add-ai";
    protected readonly steps: string[] = [
        'initial',
        'load', // interfaccia di caricamento file
        'processing', // fase di processing del file
        'panel' // pannello di gestione del file analizzato
    ];
    private _step: string = 'initial';
    public get step(): string {
        return this._step;
    }
    public set step(value: string) {
        if (this.steps.includes(value)) {
            this._step = value;
            this.render();
            this.viewer?.refresh();
        }
    }
    private _currentFile: BonusAddFile | null = null;
    public get currentFile(): BonusAddFile | null {
        return this._currentFile;
    }
    public set currentFile(value: BonusAddFile | null) {
        this._currentFile = value;
        if (value) {
            // metto base64 in sessionStorage per recuperarlo dopo
            const base64 = value?.base64 || null;
            bonusAiStorage.set(base64);
        }
        this.step = value ? 'processing' : 'initial';
    }
    private _viewer!: BaViewerControl;
    public get viewer(): BaViewerControl {
        return this._viewer;
    }
    public set viewer(value: BaViewerControl) {
        this._viewer = value;
    }
    private testOpenPDFViewer(file: BonusAddFile | null) {
        if (!file) {
            return;
        }
        const pathToViewer = '/pdfjs/web/viewer.html';
        const url = new URL(pathToViewer, window.location.origin);
        url.searchParams.set('session', 'bonus-current-file');
        window.open(url.toString(), '_blank');
    }
    private sessionGetAnalysData(): BonusAnalysisResult | null {
        const data = sessionStorage.getItem('bonus-analys-data');
        if (data) {
            try {
                return JSON.parse(data) as BonusAnalysisResult;
            } catch (error) {
                return null;
            }
        }
        return null;
    }
    private sessionClearAnalysData(): void {
        sessionStorage.removeItem('bonus-analys-data');
    }
    private sessionSetAnalysData(data: BonusAnalysisResult | null): void {
        if (data) {
            sessionStorage.setItem('bonus-analys-data', JSON.stringify(data));
        } else {
            this.sessionClearAnalysData();
        }
    }
    private _currentAnalysData: BonusAnalysisResult | null = null;
    public get currentAnalysData(): BonusAnalysisResult | null {
        if (!this._currentAnalysData) {
            this._currentAnalysData = this.sessionGetAnalysData();
        }
        return this._currentAnalysData;
    }
    public set currentAnalysData(value: BonusAnalysisResult | null) {
        this.sessionSetAnalysData(value);
        this._currentAnalysData = value;
        this.step = value ? 'panel' : 'initial';
    }

    get hasFile(): boolean {
        return this.currentFile !== null;
    }
    constructor() {
        super();
        this.setupStepNavigation();
        window.ba = this; // per debug
        window.bax =()=> {
            this.step='panel';
            setTimeout(() => {
                (document
                    .querySelector('block-analyzed-parameters') as any)
                    ?.openModal();
            }, 500);
        }
    }

    private setupStepNavigation() {
        this.on('click', '[data-go-step]', (event: Event) => {
            event.preventDefault();
            const target = event.target as HTMLElement;
            const stepName = target.dataset.goStep;
            if (stepName) {
                this.step = stepName;
            }
        });
    }
    private buildRenderingDataInitial(): Record<string, any> {
        return {};
    }
    protected buildRenderingData(): Record<string, any> {
        const stepBuilder = `buildRenderingData${this.step.charAt(0).toUpperCase() + this.step.slice(1)}`;
        let stepData: Record<string, any> = {};
        if (typeof (this as any)[stepBuilder] === 'function') {
            stepData = (this as any)[stepBuilder]() as Record<string, any>;
        }
        const commonData = {
            user: this.user,
            step: this.step,
        };
        return {
            ...commonData,
            ...stepData
        };
    }
    beforeRender(): void {
        // cancella tutte le classi legate agli step
        this.steps.forEach(s => this.classList.remove(`${s}`));
        // aggiunge la classe dello step corrente
        this.classList.add(`${this.step}`);
    }
    afterRender(): void {
        this._viewer = this.querySelector('ba-viewer-control') as BaViewerControl;
        if (!this._viewer) {
            throw new Error("BonusAddAi: ba-viewer-control element not found in template");
        }
    }
    protected render(): void {
        if (!this.user) {
            // non renderizzo se non sono loggato
            return;
        }
        this.beforeRender();
        // this._templateId = `bonus-add-ai-${step}`;
        super.render();
    }
    static registerElement(): void {
        super.registerElement();
        BaFile.registerElement();
        BaProcessing.registerElement();
        BaPanel.registerElement();
        BaViewerControl.registerElement();
    }
}